import { Component } from '@angular/core';
import {
    ErrorInterface,
    InsurancePolicyActionService,
    NewModalModule,
    NewModalRef as ModalRef,
    PurchasedProductInterface
} from 'outshared-lib';
import {
    WucButtonModule,
    WucCardModule,
    WucIconUiModule,
    WucLinkModule,
    WucListModule
} from '@inshared/website-ui-components';
import { NgForOf, NgIf } from '@angular/common';

@Component({
    standalone: true,
    selector: 'ins-insurance-revive-product-modal',
    templateUrl: 'insurance-revive-product.modal.html',
    imports: [
        NewModalModule,
        NgForOf,
        NgIf,
        WucButtonModule,
        WucCardModule,
        WucIconUiModule,
        WucLinkModule,
        WucListModule,
    ]
})
export class InsuranceReviveProductModal {

    public purchasedProduct: PurchasedProductInterface;
    public isDisabled: boolean;
    public errors: ErrorInterface[];

    constructor(
        private modalRef: ModalRef<InsuranceReviveProductModal>,
        private insurancePolicyActionService: InsurancePolicyActionService,
    ) {
        this.isDisabled = false;
        this.errors = [];
    }

    public closeModal(): void {
        this.modalRef.close();
    }

    public reviveProduct(): void {
        this.insurancePolicyActionService
            .reviveProduct$({
                productId: this.purchasedProduct.productId,
                productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            })
            .subscribe({
                next: () => this.onReviveProductSuccess(),
                error: (errors) => this.onReviveProductError(errors),
            });

        this.isDisabled = true;
        this.errors = [];
    }

    private onReviveProductSuccess(): void {
        this.isDisabled = false;
        this.errors = [];
        this.closeModal();
    }

    private onReviveProductError(errors: ErrorInterface[]): void {
        this.isDisabled = false;
        this.errors = errors;
    }
}
